<ion-alert
	[isOpen]="alertService.showsAlert$ | async"
	[header]="alertService.alertMessage$ | async"
	[buttons]="alertService.alertButtons$ | async"
	backdrop-dismiss="false"></ion-alert>
